import React from 'react';
import { Sparkles, BookOpen, Library, Upload, TrendingUp, Workflow } from "lucide-react";

const QuickLinks = ({ onNavigate }) => {
  const quickLinks = [
    { 
      icon: Workflow, 
      label: "Workflow Editor", 
      color: "bg-purple-500",
      action: "workflow" 
    },
    { 
      icon: Sparkles, 
      label: "Generate Content", 
      color: "bg-blue-500",
      action: "generate-content" 
    },
    { 
      icon: Upload, 
      label: "Upload Visuals", 
      color: "bg-indigo-500",
      action: "upload-image" 
    },
    { 
      icon: BookOpen, 
      label: "Lesson Planner", 
      color: "bg-cyan-500",
      action: "lesson-planner" 
    },
    { 
      icon: TrendingUp, 
      label: "Student Progress", 
      color: "bg-blue-600",
      action: "student-tracker" 
    },
    { 
      icon: Library, 
      label: "Resource Library", 
      color: "bg-blue-400",
      action: "resource-library" 
    },
  ];

  return (
    <div>
      <h2 className="text-xl font-bold text-gray-900 mb-6">Quick Links</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {quickLinks.map((link, index) => (
          <button
            key={index}
            onClick={() => onNavigate && onNavigate({ id: link.action, label: link.label })}
            className="bg-white p-6 rounded-xl border border-gray-200 hover:border-blue-300 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 group"
          >
            <div
              className={`w-12 h-12 ${link.color} rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-200`}
            >
              <link.icon className="w-6 h-6 text-white" />
            </div>
            <p className="font-medium text-gray-900 text-sm">{link.label}</p>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickLinks;